// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cvls-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1.5px solid #e2e8f0;
  border-radius: 999px;
  padding: 3px;
  background: #fff;
}

.cvls-btn {
  box-sizing: border-box;
  display: flex;
  width: 36px;
  height: 36px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  border: none;
  outline: none;
  transition: background 0.15s, color 0.15s;
  flex-shrink: 0;
  padding: 0;
}

.cvls-btn--active {
  background: #0860e6 !important;
  color: #fff !important;
}

.cvls-btn--inactive {
  background: transparent !important;
  color: #6b7280;
}

.cvls-btn--inactive:hover {
  background: #f3f4f6 !important;
  color: #374151;
}

.cvls-btn--edit {
  background: #f8fafc;
  color: #64748b;
}

.cvls-btn--edit:hover {
  background: #f1f5f9;
  color: #334155;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/CartViewLayoutSection/CartViewLayoutSection.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".cvls-wrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 999px;\n  padding: 3px;\n  background: #fff;\n}\n\n.cvls-btn {\n  box-sizing: border-box;\n  display: flex;\n  width: 36px;\n  height: 36px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  cursor: pointer;\n  border: none;\n  outline: none;\n  transition: background 0.15s, color 0.15s;\n  flex-shrink: 0;\n  padding: 0;\n}\n\n.cvls-btn--active {\n  background: #0860e6 !important;\n  color: #fff !important;\n}\n\n.cvls-btn--inactive {\n  background: transparent !important;\n  color: #6b7280;\n}\n\n.cvls-btn--inactive:hover {\n  background: #f3f4f6 !important;\n  color: #374151;\n}\n\n.cvls-btn--edit {\n  background: #f8fafc;\n  color: #64748b;\n}\n\n.cvls-btn--edit:hover {\n  background: #f1f5f9;\n  color: #334155;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
